<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <b-card-code>
                <validation-observer ref="simpleRules">
                  <form @submit.prevent="submitForm">
                    <b-row>
                      <b-col md="4">
                        <b-form-group>
                          <label>Type</label>
                          <v-select
                            v-model="type"
                            label="name"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="None"
                            :options="['retail', 'bulk']"
                            @input="fields = []"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" v-if="type === 'retail'">
                        <b-form-group>
                          <label>Project Name</label>
                          <v-select
                            v-model="projectname"
                            label="projectname"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="None"
                            :options="projectOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" v-if="type === 'bulk'">
                        <b-form-group>
                          <label>Land Purchase</label>
                          <v-select
                            v-model="landpurchase"
                            label="villagename"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            placeholder="None"
                            :options="landpurchaseOptions"
                          >
                            <template #option="option">
                              <span>{{ option.villagename.villagename }} ({{ option.surveynonew }})</span>
                            </template>
                            <template #selected-option="option">
                              <span>{{ option.villagename.villagename }} ({{ option.surveynonew }})</span>
                            </template>
                          </v-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                      <b-button variant="primary" class="ml-2" @click="searchData">
                        <feather-icon icon="SearchIcon" class="mr-50" />
                        <span class="align-middle">Search</span>
                      </b-button>
                    </div>
                  </form>
                </validation-observer>
              </b-card-code>
              <b-card-code  v-if="fields.length">
                <report-table :data="data" :columns="fields" />
              </b-card-code>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportTable from "../../../components/ReportTable.vue";
import axios from "@/components/axios";
import Table from "@/components/Table.vue";
import BCardCode from "@core/components/b-card-code";
import flatPickr from "vue-flatpickr-component";
import GoodTableColumnSearch from "../../../components/GoodTableColumnSearch.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Form from "@/components/form/Form.vue";
import moment from "moment";
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
} from "bootstrap-vue";
const baseApi = process.env.VUE_APP_APIENDPOINT;
import vSelect from "vue-select";
export default {
  components: {
    ReportTable,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BCardCode,
    Form,
    GoodTableColumnSearch,
  },
  data() {
    return {
      result: "",
      data: "",
      type: "",
      projectname: "",
      projectOptions: [],
      landpurchase: "",
      landpurchaseOptions: [],
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem("accessToken"),
      fields: [],
    };
  },
  mounted() {
    this.getProjectname();
    this.getLandPurchase();
  },
  methods: {
    async searchData() {
      const data = {
        type: this.type,
        project_id: this.type === 'retail' ? (this.projectname && this.projectname.id) : undefined,
        village: this.type === 'bulk' ? (this.landpurchase && this.landpurchase.id) : undefined,
      };
      await axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify(data),
        url: `${this.baseApi}/inventoryreport`,
      }).then((response) => {
        this.data = response.data.data;
        if (this.type == 'retail') {
          this.fields = [
            {
              field: "project",
              label: "Project",
            },
            {
              field: "plotno",
              label: "Plot No",
            },
            {
              field: "status",
              label: "Status",
            },
            {
              field: "carpetarea_sqmt",
              label: "Plot Area(IN SQ. MTR)",
            },
            {
              field: "carpetarea_sqyds",
              label: "Plot Area(IN SQ. YARD)",
            },
            {
              field: "superarea_sqmt",
              label: "SUPER BUILT UP AREA(IN SQ. MTR)",
            },
            {
              field: "superarea_sqyds",
              label: "SUPER BUILT UP AREA(IN SQ. YARD)",
            },
            {
              field: "totalarea_sqmt",
              label: "TOTAL AREA(IN SQ. MTR)",
            },
            {
              field: "totalarea_sqyds",
              label: "TOTAL AREA(IN SQ. YARD)",
            },
            {
              field: "cornerphase",
              label: "Corner Phase",
            },
            {
              field: "gardenphase",
              label: "Garden Phase",
            },
            {
              field: "length",
              label: "Length",
            },
            {
              field: "width",
              label: "Width",
            },
            {
              field: "rateperyd",
              label: "Rate per Sq. Yard",
            },
            {
              field: "plotamount",
              label: "Total Plot Amount",
            },
            {
              field: "developmentcharge",
              label: "Development Charge (Per Sq. Yard)",
            },
            {
              field: "pnorth",
              label: "North",
            },
            {
              field: "psouth",
              label: "South",
            },
            {
              field: "peast",
              label: "East",
            },
            {
              field: "pwest",
              label: "West",
            },
          ]
          this.data.map((item) => {
            item.project = item.project && item.project.projectname;
          });
        } else {
          this.fields = [
            {
              field: "villagename",
              label: "Village Name",
            },
            {
              field: "surveynonew",
              label: "Survey No",
            },
            {
              field: "totalvalue",
              label: "Total Value",
            },
            {
              field: "propertyType",
              label: "Property Type",
            },
            {
              field: "date",
              label: "Date",
            },
            {
              field: "area",
              label: "Area",
            },
            {
              field: "rate",
              label: "Rate",
            },
            {
              field: "totalamount",
              label: "Total Amount",
            },
            {
              field: "remarks",
              label: "Remarks",
            },
          ]
          this.data.map((item) => {
            item.villagename = item.villagename && item.villagename.villagename;
          });
        }
      this.$forceUpdate();
      });
    },
    async getProjectname() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getProject`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.projectOptions = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async getLandPurchase() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getvillagedata`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.landpurchaseOptions = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
